/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import RoomEvent from '../../event/RoomEvent'
import HotelManualEvent from '../../event/HotelManualEvent'

const SettingTabletState = Record({
  edited: false,
  edit_manual: false // ハウスマニュアルが編集できるかどうか
})

class SettingTabletStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SettingTabletState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case RoomEvent.onEdit:
        return state.merge({ edited: true })

      case HotelManualEvent.fetchAll:
        return state.merge({ edit_manual: payload.hasOwnProperty('type') && payload.type === 'own' })

      default:
        return state
    }
  }
}

export default new SettingTabletStore()
